<template>
  <WdsLabel
    :label="statusLabel"
    :success="statusEnum === JobStatus.Active"
    :primary="statusEnum === JobStatus.Completed"
    :gray="statusEnum === JobStatus.Draft"
    :error="statusEnum === JobStatus.Removed"
    subtle
  />
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { WdsLabel } from '@worksome/wds-components'

import { FragmentType, graphql, useFragment } from '@/gql'
import { $t } from '@/composables/translation'
import { JobStatus } from '@/gql/graphql'

const JobStatusColumn = graphql(`
  fragment JobStatusColumn on Job {
    id
    status
    draft
    removed
    completed
  }
`)

const props = defineProps<{
  row: FragmentType<typeof JobStatusColumn>
}>()

const column = computed(() => useFragment(JobStatusColumn, props.row))

const statusEnum = computed(() => column.value.status || JobStatus.Active)

const statusLabel = computed(() => {
  switch (statusEnum.value) {
    case JobStatus.Draft:
      return $t('Draft')
    case JobStatus.Active:
      return $t('Active')
    case JobStatus.Completed:
      return $t('Completed')
    case JobStatus.Removed:
      return $t('Removed')
    default:
      return $t('Active')
  }
})
</script>

<style lang="scss"></style>
